export default "__VITE_ASSET__Bw6de0h$__"